export default "__VITE_ASSET__Bogfajls__"